import React, { useState, useEffect } from "react";
import { 
  collection, 
  getDocs, 
  addDoc, 
  doc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  runTransaction 
} from "firebase/firestore";


import { addJobTotal } from "../utils/addJobTotal";

import { db } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import "./ProposalsJMC.css";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { serverTimestamp, increment } from "firebase/firestore";

const CompletedProposals = () => {
  const [proposals, setProposals] = useState([]);
  const [properties, setProperties] = useState([]);
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [newProposal, setNewProposal] = useState({
    companyName: "",
    companyAddress: "",
    companyCityStateZip: "",
    siteName: "",
    management: "",
    managerName: "",
    address: "",
    cityStateZip: "",
    scope: "",
    jobDescription: "",
    price: "",
    proposalTotal: "",
    submittedDate: "",
    submittedBy: "",
    images: [],
    terms: "",
    warrantyName: "",     // <-- NEW
    warranty: "",         // (text body stays here)
  });
  const [proposalID, setProposalID] = useState(3000);
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [pdfDownloadUrl, setPdfDownloadUrl] = useState(""); // Add state for PDF download URL
  const navigate = useNavigate();
  const goToApproved = () => {
    navigate("/ApprovedProposals");
  };
  
  const goToCompleted = () => {
    navigate("/CompletedProposals");
  };

  const goToSentProposals = () => {
    navigate("/SentProposals");
  };

  const goToNotApprovedProposals = () => {
    navigate("/NotApprovedProposals");
  };

  const goToProposals = () => {
    navigate("/ProposalsJMC");
  };

  const goToProposalsDCS = () => {
    navigate("/ProposalsDCS");
  };
  
  const [sortOrder, setSortOrder] = useState("asc");

  // Helpers
  const formatInitials = (nameOrFirstLast) => {
    if (!nameOrFirstLast) return "";
    // Accept either "First Last" or already-initials and normalize to "F L"
    const parts = String(nameOrFirstLast).trim().split(/\s+/);
    const first = parts[0]?.[0] || "";
    const last  = parts[1]?.[0] || "";
    return [first, last].filter(Boolean).join(" ");
  };
  
  const formatDateMMDDYYYY = (isoOrYmd) => {
    if (!isoOrYmd) return "";
    // Handles "YYYY-MM-DD" from <input type="date"> or full ISO strings
    const d = new Date(isoOrYmd);
    if (Number.isNaN(d.getTime())) return isoOrYmd; // fallback
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
  };

  const termsOptions = [
    { name: "Half & Half (Commonly used)", content: "A deposit of 50% of the total contract amount is due upon acceptance of this quote. The remaining balance is payable in full upon completion of the work." },
    { name: "1/3 & 1/3", content: "Payment will be made in three equal installments: one-third (1/3) deposit upon acceptance, one-third (1/3) prior to the start of work, and the final one-third (1/3) upon completion." },
    { name: "1/2 & Progress (recommened for large projects)", content: "A 50% deposit is required upon acceptance. The remaining balance will be invoiced in progress payments, with the final payment due upon completion." },
    { name: "1/3 & Progress", content: "A one-third (1/3) deposit is required upon acceptance. The remaining balance will be invoiced in progress payments, with the final payment due upon completion." },
  ];

  const logoOptions = [
    { name: "JMC Contracting Group LLC", url: "https://firebasestorage.googleapis.com/v0/b/servicing-head-quarters.firebasestorage.app/o/images%2Fjmc-logo.png?alt=media&token=befb44e5-ec5d-4cd9-b880-ac8281478628", alignment: "center" }
  ];

  const JMC_NAME = "JMC Contracting Group LLC";

  const [selectedLogo, setSelectedLogo] = useState(logoOptions[0]);

  const handleLogoChange = (e) => {
    const selected = logoOptions.find(option => option.name === e.target.value);
    setSelectedLogo(selected);
  };

  const [warrantyOptions] = useState([
    {
      name: "Property Warranty",
      content: ({ companyName, siteName }) => `
  All work will be completed in a workmanlike manner according to standard practices. Any alteration or deviation from the above specifications involving extra costs will only be performed upon a written change order, and such costs shall become an extra charge over and above the contract price. No guarantees are expressed or implied regarding the effectiveness of work. Performance may be delayed by circumstances beyond the contractor’s control, including but not limited to weather, strikes, supply shortages, or other acts not controlled by ${companyName}.
  
  Deposits are strictly non-refundable once email or written approval is received, or once a signed proposal is executed. Should the Client choose to hire another vendor or cancel the project after providing approval, ${companyName} shall retain the deposit in full and reserves the right to recover costs of all labor, materials purchased, mobilization, preparation, or administrative work performed up to that date. The Client acknowledges that the Contractor cannot be removed from an approved job without the Contractor’s written consent, and any attempted cancellation without consent shall constitute breach of contract.
  
  Due to supply chain and availability issues, certain materials may be substituted with equal or greater quality alternatives at the discretion of ${companyName}, without prior notice and without penalty.
  
  ${companyName} performs all work under the guidelines of the state and/or county where work is being performed and complies with all applicable permit requirements. If permits are required, the cost of those permits shall be the responsibility of ${siteName}.
  
  ${companyName} is not responsible for direct or incidental damage to any items such as (but not limited to) landscaping, irrigation systems, underground utilities, or property features, except in cases of willful misconduct or gross negligence. Any alleged damage must be reported within 48 hours of occurrence, and ${companyName} must be given the opportunity to correct such damage. Proposal pricing does not include alterations required due to hidden or concealed conditions; any such work shall result in additional charges.
  
  ${companyName} provides a One-Year Limited Workmanship Warranty from the date of completion. This warranty does not cover damages or failures caused by: structural defects, settlement, improper drainage, fire, explosion, chemical exposure, extreme weather, vandalism, negligence, acts of God, or other causes beyond the Contractor’s control. This Warranty is applicable only to ${siteName}.
  
  In the event of a dispute, ${companyName} shall be entitled to recover reasonable attorney’s fees and costs associated with enforcing this contract.
  `.trim()
    },
    {
      name: "Homeowners Repair",
      content: ({ companyName }) => `
  ${companyName} warrants its workmanship for thirty (30) days from the date of completion for the specific repair(s) performed. During this period, ${companyName} will correct defects in workmanship at no additional charge.
  
  This limited repair warranty excludes: materials or manufacturer defects; normal wear and tear; damage from abuse, misuse, neglect, improper maintenance, or alterations by others; hidden or concealed conditions; pre-existing conditions; and any damage caused by water intrusion, moisture, mold, pests, pets, or acts of God (including but not limited to storms, flooding, wind, freeze/thaw, lightning), vandalism, or other events beyond the Contractor’s control. No coverage is provided for cosmetic concerns not arising from workmanship. Any product warranties are solely those of the manufacturer.
  `.trim()
    },
    {
      name: "Homeowners Projects",
      content: ({ companyName }) => `
  ${companyName} warrants its workmanship for sixty (60) days from the date of completion for the project scope described in this proposal. ${companyName} will correct defects in workmanship discovered and reported within this period.
  
  Exclusions: materials or manufacturer defects; normal wear and tear; movement, settlement, or structural issues; improper drainage or water management; damage due to owner or third-party work; hidden or concealed conditions; pre-existing conditions; environmental or site conditions; and damage from water intrusion, moisture, mold, pests, pets, or acts of God (including storms, flooding, wind, freeze/thaw, lightning), vandalism, or other events beyond the Contractor’s control. Cosmetic variations inherent to materials or minor touch-up needs are not covered. Manufacturer warranties, if any, are solely those of the manufacturer.
  `.trim()
    },
    {
      name: "No Warranty",
      content: () => "" // nothing; we'll hide the section
    }
  ]);

  const handleWarrantyChange = (e) => {
    const name = e.target.value;
    const found = warrantyOptions.find(opt => opt.name === name);
    if (!found) return;
  
    const text = found.content({
      companyName: newProposal.companyName || selectedProposal?.companyName || "",
      siteName: newProposal.siteName || selectedProposal?.siteName || ""
    });
  
    setNewProposal(prev => ({
      ...prev,
      warrantyName: name,
      warranty: text
    }));
  };

  useEffect(() => {
    const fetchProposals = async () => {
      const proposalsRef = collection(db, "proposals");
    
      // ONLY pull proposals for JMC
      const q = query(
        proposalsRef,
        where("companyName", "==", "JMC Contracting Group LLC")
      );
    
      const querySnapshot = await getDocs(q);
    
      const proposalsData = querySnapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(p => p.status === "Completed");
    
      setProposals(proposalsData);
    };
    

    const fetchProperties = async () => {
      const propertiesRef = collection(db, "properties");
      const querySnapshot = await getDocs(propertiesRef);
      const propertiesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProperties(propertiesData);
    };

    const fetchUsers = async () => {
      const usersRef = collection(db, "users");
      const querySnapshot = await getDocs(usersRef);
      const usersData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(usersData);
    };

    const fetchCompanies = async () => {
      const companiesRef = collection(db, "companies");
      const querySnapshot = await getDocs(companiesRef);
      const companiesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCompanies(companiesData);
    };

    fetchProposals();
    fetchProperties();
    fetchUsers();
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (selectedProposal) {
      setNewProposal({
        companyName: selectedProposal.companyName || "",
        companyAddress: selectedProposal.companyAddress || "",
        companyCityStateZip: selectedProposal.companyCityStateZip || "",
        siteName: selectedProposal.siteName || "",
        management: selectedProposal.management || "",
        managerName: selectedProposal.managerName || "",
        address: selectedProposal.address || "",
        cityStateZip: selectedProposal.cityStateZip || "",
        scope: selectedProposal.scope || "",
        jobDescription: selectedProposal.jobDescription || "",
        price: selectedProposal.price || "",
        proposalTotal: selectedProposal.proposalTotal || selectedProposal.contractAmount || selectedProposal.estimatedTotal || "",
        submittedDate: selectedProposal.submittedDate || "",
        submittedBy: selectedProposal.submittedBy || "",
        images: selectedProposal.images || [],
        terms: selectedProposal.terms || "",
        warrantyName: selectedProposal.warrantyName || "",  // <-- NEW
        warranty: selectedProposal.warranty || "",          // text
      });
    }
  }, [selectedProposal]);

  const sortedProperties = properties.sort((a, b) => a.propertyName.localeCompare(b.propertyName));

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewProposal((prev) => ({ ...prev, [name]: value }));
  };

  const handleCompanyNameChange = (e) => {
    const selectedCompany = companies.find(company => company.companyName === e.target.value);
    const matchedLogo = logoOptions.find(logo => logo.name === selectedCompany.companyName);
    setNewProposal((prev) => ({
      ...prev,
      companyName: selectedCompany.companyName,
      companyAddress: selectedCompany.companyAddress || "",
      companyCityStateZip: `${selectedCompany.companyCity}, ${selectedCompany.companyState} ${selectedCompany.companyZip}` || ""
    }));
    if (matchedLogo) {
      setSelectedLogo(matchedLogo);
    }
  };

  const handleSiteNameChange = (e) => {
    const selectedProperty = properties.find(property => property.propertyName === e.target.value);
    setNewProposal((prev) => ({
      ...prev,
      siteName: selectedProperty.propertyName,
      management: selectedProperty.management || "",
      managerName: selectedProperty.managerName || "",
      address: selectedProperty.address || selectedProperty.managementAddress || "",
      cityStateZip: `${selectedProperty.city || selectedProperty.managementCity}, ${selectedProperty.state || selectedProperty.managementState} ${selectedProperty.zip || selectedProperty.managementZip}` || ""
    }));
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setNewProposal(prevState => ({
      ...prevState,
      images: [...prevState.images, ...selectedFiles], // Append new files without removing URLs
    }));
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { images, ...proposalData } = newProposal;
      const proposalDocRef = await addDoc(collection(db, "proposals"), {
        ...proposalData,
        status: "Not Sent",
        hasBeenSent: false
      });
      let imageURLs = [];
      if (images.length > 0) {
        const storage = getStorage();
        const uploadPromises = images.map(async (file) => {
          const storageRef = ref(storage, `proposals/${proposalDocRef.id}/${file.name}`);
          await uploadBytes(storageRef, file);
          return await getDownloadURL(storageRef);
        });
        imageURLs = await Promise.all(uploadPromises);
        await updateDoc(proposalDocRef, { imageURLs });
      }

      setProposals([...proposals, { id: proposalDocRef.id, ...proposalData, imageURLs }]);
      setProposalID(proposalID + 1);
      setNewProposal({
        companyName: "",
        companyAddress: "",
        companyCityStateZip: "",
        siteName: "",
        management: "",
        managerName: "",
        address: "",
        cityStateZip: "",
        scope: "",
        jobDescription: "",
        price: "",
        proposalTotal: "",
        submittedDate: "",
        submittedBy: "",
        images: [],
        terms: "",
        warranty: "",
      });
      setIsEditing(false);
    } catch (error) {
      console.error("Error adding proposal:", error);
    }
  };

  const handleEditProposal = async () => {
    try {
      const proposalRef = doc(db, "proposals", selectedProposal.id);
  
      // Extract files from newProposal.images
      const files = newProposal.images.filter(img => img instanceof File);
      let imageURLs = selectedProposal.imageURLs || []; // Keep existing URLs
  
      if (files.length > 0) {
        const storage = getStorage();
        const uploadPromises = files.map(async (file) => {
          const storageRef = ref(storage, `proposals/${selectedProposal.id}/${file.name}`);
          await uploadBytes(storageRef, file);
          return await getDownloadURL(storageRef);
        });
  
        const uploadedImageURLs = await Promise.all(uploadPromises);
        imageURLs = [...imageURLs, ...uploadedImageURLs]; // Merge new and old URLs
      }
  
      // Update Firestore (store URLs, not files)
      await updateDoc(proposalRef, { 
        ...newProposal, 
        images: imageURLs 
      });
  
      // Update UI
      setProposals(proposals.map(proposal => 
        proposal.id === selectedProposal.id ? { ...proposal, images: imageURLs } : proposal
      ));
  
      setSelectedProposal({ ...selectedProposal, images: imageURLs });
      setIsEditing(false);
    } catch (error) {
      console.error("Error updating proposal:", error);
    }
  };
  

  const handleDeleteProposal = async () => {
    try {
      const proposalRef = doc(db, "proposals", selectedProposal.id);
      await deleteDoc(proposalRef);
      setProposals(proposals.filter(proposal => proposal.id !== selectedProposal.id));
      setSelectedProposal(null);
      setShowDeleteConfirm(false);
    } catch (error) {
      console.error("Error deleting proposal:", error);
    }
  };

  const handleCancel = () => {
    setNewProposal({
      companyName: "",
      companyAddress: "",
      companyCityStateZip: "",
      siteName: "",
      management: "",
      managerName: "",
      address: "",
      cityStateZip: "",
      scope: "",
      jobDescription: "",
      price: "",
      submittedDate: "",
      submittedBy: "",
      images: [],
      terms: "",
      warranty: "",
    });
    setIsEditing(false);
  };

  const parseJobDescription = (description) => {
    if (!description) return null;
    return description.split('\n').map((line, index) => {
      if (line.startsWith('((b))')) {
        return <p key={index} className="bold">{line.replace('((b))', '')}</p>;
      } else if (line.startsWith('((i))')) {
        return <p key={index} className="italic">{line.replace('((i))', '')}</p>;
      } else if (line.startsWith('((-))')) {
        return <li key={index} className="bullet">{line.replace('((-))', '')}</li>;
      } else {
        return <p key={index}>{line}</p>;
      }
    });
  };

  const handleEditClick = () => {
    if (selectedProposal) {
      setNewProposal({
        companyName: selectedProposal.companyName || "",
        companyAddress: selectedProposal.companyAddress || "",
        companyCityStateZip: selectedProposal.companyCityStateZip || "",
        siteName: selectedProposal.siteName || "",
        management: selectedProposal.management || "",
        managerName: selectedProposal.managerName || "",
        address: selectedProposal.address || "",
        cityStateZip: selectedProposal.cityStateZip || "",
        scope: selectedProposal.scope || "",
        jobDescription: selectedProposal.jobDescription || "",
        price: selectedProposal.price || "",
        proposalTotal: selectedProposal.proposalTotal || selectedProposal.contractAmount || selectedProposal.estimatedTotal || "",
        submittedDate: selectedProposal.submittedDate || "",
        submittedBy: selectedProposal.submittedBy || "",
        images: selectedProposal.images || [],
        terms: selectedProposal.terms || "",
        warranty: selectedProposal.warranty || "",
      });
      setIsEditing(true);
    }
  };
  
  // Put this above your component or inside it before return
  const openPrintPreview = () => {
    const printable = document.getElementById("printableArea");
    if (!printable) return;
  
    // Create hidden iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.setAttribute("aria-hidden", "true");
    document.body.appendChild(iframe);
  
    const doc = iframe.contentWindow || iframe.contentDocument;
    const iDoc = doc.document || doc;
  
    const content = printable.outerHTML;
    const printCss = `
  <style>
    /* Paper */
    @page {
      size: Letter;           /* change to A4 if you prefer */
      margin: 0.5in;
    }
    html, body {
      margin: 0;
      padding: 0;
      height: 100%;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      color: #111;
      font: 12pt/1.35 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
    }

    /* Hide app controls in print */
    @media print { .no-print { display: none !important; } }

    /* Make the layout single-column in print (so it can break naturally) */
    @media print {
      .row-container {
        display: block !important;        /* kill flex for print */
      }
      .row-container > * {
        width: 100% !important;           /* each card full-width in order */
      }
    }

    @media print {
  .companyinfo-container,
  .property-container {
    box-sizing: border-box !important;
    width: 100% !important;
    margin: 0 0 12px 0 !important;

    /* double-up border protection so the right edge never drops in print */
    border: 1px solid #000 !important;
    border-right: 1px solid #000 !important;
    background: #fff !important;
    background-clip: padding-box !important;

    /* safety outline (some Chrome print engines drop the last border pixel) */
    outline: 0.5pt solid #000 !important;
    outline-offset: 0 !important;
  }

  /* Total paragraph: respect newlines from textarea */
  .total-text {
    white-space: pre-line !important;  /* \n => line breaks */
    line-height: 1.35;
    font-size: 11pt;
  }
}

    /* Logo smaller */
    .companylogo-container { text-align: center; margin: 0 0 12px 0; }
    .companylogo-container img.resizable-logo {
      width: 120px !important;
      max-width: 120px !important;
      height: auto !important;
      display: inline-block;
    }

    /* Outer page frame */
    .page-border {
      border: 1px solid #333 !important;
      border-radius: 6px;
      padding: 16px;
      box-shadow: none !important;
      background: #fff !important;
    }

    /* Section cards — allow breaking through them */
    .companyinfo-container,
    .property-container,
    .scope-container,
    .description-container,
    .total-container,
    .image-container,
    .terms-container,
    .warranty-container,
    .acceptance-container,
    .noteacceptance-container {
      border: 1px solid #999 !important;
      border-radius: 6px;
      padding: 12px;
      background: #fff !important;
      box-shadow: none !important;
      margin-bottom: 12px;

      /* ✨ Let sections split across pages if they are tall */
      break-inside: auto !important;
      page-break-inside: auto !important;
      overflow: visible !important;
    }

    /* Text tweaks */
    .companyinfo-container p,
    .property-container p,
    .scope-container p,
    .description-container p,
    .total-container p,
    .terms-container p,
    .warranty-container p,
    .noteacceptance-container p,
    .acceptance-container p {
      margin: 4px 0;
      font-size: 10.5pt;
      line-height: 1.3;
      word-break: break-word;
      overflow-wrap: anywhere;
    }

    .warranty-container p {
  text-indent: 2em;   /* adjust indent size */
  margin-top: 6px;    /* optional spacing above */
}

    /* Bullets/formatting */
    .job-bullet { display: block; margin-left: 10px; }
    .job-bold   { font-weight: 700; }
    .job-italic { font-style: italic; }

    /* Images: grid that can flow to the next page naturally */
    .image-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 8px;
      justify-content: center;
    }
    .image-wrapper {
      border: 1px solid #bbb;
      border-radius: 4px;
      background: #fafafa;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      width: 100%;
      aspect-ratio: 1 / 1; /* square cells; no fixed px height so they can flow */
      /* Each image "tile" stays intact, but the grid continues on next page */
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .proposal-image { width: 100%; height: 100%; object-fit: contain; }

    /* Signature row is small; allow it to break if needed */
    .signature-row p { font-size: 10.5pt; margin: 2px 0; }

    /* Utility: force a page break if you insert <div class="page-break"></div> */
    .page-break { break-before: page; page-break-before: always; }
  </style>
`;

  
    iDoc.open();
    iDoc.write(`
      <!doctype html>
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Proposal</title>
          ${printCss}
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);
    iDoc.close();
  
    const doPrint = () => {
      try { (iframe.contentWindow || iframe).focus(); } catch {}
      try { (iframe.contentWindow || iframe).print(); } catch {}
      // Clean up after a bit
      setTimeout(() => {
        try { document.body.removeChild(iframe); } catch {}
      }, 1000);
    };
  
    if ((iframe.contentDocument || iframe).readyState === "complete") {
      setTimeout(doPrint, 150);
    } else {
      iframe.onload = () => setTimeout(doPrint, 150);
    }
  };
  


  const handlePrint = async () => {
    if (!selectedProposal) return;
  
    // 1) Open the print preview immediately (keeps user gesture intact)
    openPrintPreview();
  
    // 2) Then do your PDF creation + upload in the background of this handler
    try {
      const now = new Date();
      const timestamp = now.toISOString();
      const formattedTimestamp = now.toISOString().replace(/[-T:]/g, "").split(".")[0];
      const proposalPDFname = `${selectedProposal.siteName} ${selectedProposal.scope} ${formattedTimestamp}.pdf`.replace(/[/\\?%*:|"<>]/g, "");
  
      // Create a simple PDF (or call your generatePDF(proposal) if preferred)
      const doc = new jsPDF();
      doc.text(`Proposal for ${selectedProposal.siteName}`, 10, 10);
      doc.text(`Scope: ${selectedProposal.scope}`, 10, 20);
      doc.text(`Submitted By: ${formatInitials(selectedProposal.submittedBy)} on ${formatDateMMDDYYYY(selectedProposal.submittedDate)}`, 10, 30);
  
      const pdfBlob = doc.output("blob");
  
      const storage = getStorage();
      const pdfRef = ref(storage, `proposals/${selectedProposal.id}/pdfs/${proposalPDFname}`);
  
      await uploadBytes(pdfRef, pdfBlob);
      const downloadURL = await getDownloadURL(pdfRef);
      setPdfDownloadUrl(downloadURL);
  
      // Record in subcollection
      const proposalPdfsRef = collection(db, `proposals/${selectedProposal.id}/pdfs`);
      await addDoc(proposalPdfsRef, {
        proposalPDF: downloadURL,
        proposalPDFname,
        timestamp,
        dateTimeString: now.toLocaleString(),
      });
  
      // Associate to job if match exists
      await matchAndAddPdfToJob(
        selectedProposal.siteName,
        selectedProposal.scope,
        downloadURL,
        proposalPDFname,
        timestamp,
        now.toLocaleString()
      );
  
      // Optional: auto-open the saved PDF in a new tab so they can print the real PDF too
      // window.open(downloadURL, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error("Error uploading PDF:", err);
      // Optional non-blocking UI feedback here
    }
  };
  
  
  const matchAndAddPdfToJob = async (siteName, scope, pdfURL, pdfName, timestamp, dateTimeString) => {
    try {
      // Fetch jobs collection
      const jobsRef = collection(db, "jobs");
      const querySnapshot = await getDocs(jobsRef);
  
      // Find a job that matches the siteName and scope
      const matchingJobDoc = querySnapshot.docs.find(
        (doc) => doc.data().siteName === siteName && doc.data().scope === scope
      );
  
      if (matchingJobDoc) {
        const jobId = matchingJobDoc.id;
        const jobRef = doc(db, "jobs", jobId);
  
        // Get existing PDFs array or initialize a new one
        const existingJobData = matchingJobDoc.data();
        const existingPdfs = existingJobData.proposalPdfs || [];
  
        // Add the new PDF to the array
        const updatedPdfs = [...existingPdfs, { pdfURL, pdfName, timestamp, dateTimeString }];
  
        // Update Firestore with the new PDF
        await updateDoc(jobRef, { proposalPdfs: updatedPdfs });
  
        console.log(`PDF successfully added to job with ID: ${jobId}`);
      } else {
        console.warn(`No matching job found for Site: ${siteName}, Scope: ${scope}`);
      }
    } catch (error) {
      console.error("Error updating job with PDF:", error);
    }
  };
  
const getImageData = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

const generatePDF = async (proposal, fontSize = 12, termsFontSize = 12, termsFontStyle = 'normal') => {
    const doc = new jsPDF();
    doc.setFontSize(fontSize);
    
    // Add border
    doc.rect(10, 10, 190, 277);

    // Logo container
    doc.setDrawColor(0);
    doc.setFillColor(255, 255, 255);
    doc.rect(15, 20, 180, 30, 'FD');
    doc.text("Logo:", 20, 30);
    if (proposal.logo) {
        const logoImage = await getImageData(proposal.logo);
        doc.addImage(logoImage, 'JPEG', 20, 35, 50, 15);
    }

    let yOffset = 60;

    // Company container
    doc.setFillColor(255, 255, 255);
    const companyHeight = 10 + (proposal.companyName ? 10 : 0) + (proposal.companyAddress ? 10 : 0) + (proposal.companyCityStateZip ? 10 : 0);
    doc.rect(15, yOffset, 180, companyHeight, 'FD');
    doc.text("Company:", 20, yOffset + 10);
    if (proposal.companyName) doc.text(proposal.companyName, 105, yOffset + 20, { maxWidth: 170, align: 'center' });
    if (proposal.companyAddress) doc.text(proposal.companyAddress, 105, yOffset + 30, { maxWidth: 170, align: 'center' });
    if (proposal.companyCityStateZip) doc.text(proposal.companyCityStateZip, 105, yOffset + 40, { maxWidth: 170, align: 'center' });
    yOffset += companyHeight + 10;

    // Site container
    const siteHeight = 10 + (proposal.siteName ? 10 : 0) + (proposal.management ? 10 : 0) + (proposal.managerName ? 10 : 0) + (proposal.address ? 10 : 0);
    doc.rect(15, yOffset, 180, siteHeight, 'FD');
    doc.text("Site:", 20, yOffset + 10);
    if (proposal.siteName) doc.text(`Site: ${proposal.siteName}`, 20, yOffset + 20, { maxWidth: 170 });
    if (proposal.management) doc.text(`Management: ${proposal.management}`, 20, yOffset + 30, { maxWidth: 170 });
    if (proposal.managerName) doc.text(`Manager: ${proposal.managerName}`, 20, yOffset + 40, { maxWidth: 170 });
    if (proposal.address) doc.text(`Address: ${proposal.address}`, 20, yOffset + 50, { maxWidth: 170 });
    yOffset += siteHeight + 10;

    // Scope container
    const scopeHeight = 20;
    doc.rect(15, yOffset, 180, scopeHeight, 'FD');
    doc.text("Scope:", 20, yOffset + 10);
    doc.text(proposal.scope || '', 20, yOffset + 20, { maxWidth: 170 });
    yOffset += scopeHeight + 10;

    // Job Description container
    const jobDescriptionLines = (proposal.jobDescription || '').split('\n');
    const jobDescriptionText = jobDescriptionLines.map(line => `• ${line}`).join('\n');
    const jobDescriptionHeight = jobDescriptionLines.length * 10 + 10; // Adjust height based on line count

    doc.rect(15, yOffset, 180, jobDescriptionHeight, 'FD'); // Single container
    doc.text("Job Description:", 20, yOffset + 10);
    doc.text(jobDescriptionText, 20, yOffset + 20, { maxWidth: 170, align: 'left' });

    yOffset += jobDescriptionHeight + 10; // Adjust for next section

    // Total Price container
    const totalPriceHeight = 20;
    doc.rect(15, yOffset, 180, totalPriceHeight, 'FD');
    doc.text("Total Price:", 20, yOffset + 10);
    doc.text(`$${proposal.price || ''}`, 20, yOffset + 20, { maxWidth: 170 });
    yOffset += totalPriceHeight + 10;

    // Options container
    if (proposal.options && proposal.options.length > 0) {
        doc.addPage();
        yOffset = 10;
        const optionsHeight = 20 + proposal.options.length * 10;
        doc.setFillColor(255, 255, 255);
        doc.rect(15, yOffset, 180, optionsHeight, 'FD');
        doc.text("Options:", 20, yOffset + 10);
        proposal.options.forEach((option, index) => {
            doc.text(`Option ${String.fromCharCode(65 + index)} Total: ${option}`, 20, yOffset + 20 + index * 10, { maxWidth: 170 });
        });
        yOffset += optionsHeight + 10;
    }

    // Additional Note container
    doc.addPage();
    yOffset = 10;
    const additionalNoteHeight = 30;
    doc.setFillColor(255, 255, 255);
    doc.rect(15, yOffset, 180, additionalNoteHeight, 'FD');
    doc.text("Additional Note:", 20, yOffset + 10);
    doc.text(proposal.additionalNote || '', 20, yOffset + 20, { maxWidth: 170 });
    yOffset += additionalNoteHeight + 10;

    // Image Upload container
    if (proposal.images && proposal.images.length > 0) {
        doc.addPage();
        yOffset = 10;
        const imagesHeight = 20 + Math.ceil(proposal.images.length / 3) * 110; // Adjust height based on image count
        doc.setFillColor(255, 255, 255);
        doc.rect(15, yOffset, 180, imagesHeight, 'FD');
        doc.text("Images:", 20, yOffset + 10);
        for (const [index, imageUrl] of proposal.images.entries()) {
            const imageData = await getImageData(imageUrl);
            const x = 20 + (index % 3) * 60; // Adjust x position for 3 images per row
            const y = yOffset + 20 + Math.floor(index / 3) * 100; // Adjust y position for each row
            doc.addImage(imageData, 'JPEG', x, y, 50, 50); // Adjust
        }
        yOffset += imagesHeight + 10;
    }

    // Add page break for terms
    doc.addPage();
    yOffset = 10;
    doc.rect(10, 10, 190, 277);
    
    // Terms & Conditions
    doc.setFontSize(termsFontSize);
    doc.setFont('helvetica', termsFontStyle);
    doc.text("Terms & Conditions:", 15, yOffset + 10);

    // Handle line breaks in terms
    const termsLines = (proposal.terms || '').split('\n');
    yOffset += 20;
    termsLines.forEach(line => {
        doc.text(line, 15, yOffset, { maxWidth: 180 });
        yOffset += 10;
    });
    
    // Save PDF
    const filename = `${proposal.siteName} ${proposal.scope}`.replace(/[/\\?%*:|"<>]/g, '') + '.pdf';
doc.save(filename);
};

const generateAndUploadPDF = async () => {
    const doc = new jsPDF();
    doc.text("This is a dynamically created PDF stored in Firebase!", 10, 10);
    const pdfBlob = doc.output("blob");

    const storage = getStorage();
    const pdfRef = ref(storage, `generated_pdfs/my_generated_pdf.pdf`);

    try {
      const snapshot = await uploadBytes(pdfRef, pdfBlob);
      const downloadURL = await getDownloadURL(snapshot.ref);
      console.log("PDF uploaded successfully:", downloadURL);

      document.getElementById("pdfLink").href = downloadURL;
      document.getElementById("pdfLink").innerText = "Download Generated PDF";
      document.getElementById("pdfViewer").src = downloadURL;
    } catch (error) {
      console.error("Error uploading PDF:", error);
    }
  };

const handleAddProposalClick = () => {
  const jmc = companies.find(c => c.companyName === JMC_NAME);
  setNewProposal({
    companyName: JMC_NAME,
    companyAddress: jmc?.companyAddress || "",
    companyCityStateZip: jmc ? `${jmc.companyCity}, ${jmc.companyState} ${jmc.companyZip}` : "",
    siteName: "",
    management: "",
    managerName: "",
    address: "",
    cityStateZip: "",
    scope: "",
    jobDescription: "",
    price: "",
    proposalTotal: "",
    submittedDate: "",
    submittedBy: "",
    images: [],
    terms: "",
    warrantyName: "",
    warranty: "",
  });
  // ensure the JMC logo is selected
  setSelectedLogo(logoOptions[0]);
  setIsEditing(true);
};


const handleCloseDetails = () => {
  setSelectedProposal(null);
};

const handleDeleteProposalDirect = async (proposalId) => {
  try {
    const proposalRef = doc(db, "proposals", proposalId);
    await deleteDoc(proposalRef);
    setProposals(prev => prev.filter(p => p.id !== proposalId));
  } catch (error) {
    console.error("Error deleting proposal:", error);
    alert("Failed to delete proposal.");
  }
};

const handleMarkCompleted = async (proposal) => {
  try {
    const proposalRef = doc(db, "proposals", proposal.id);

    await updateDoc(proposalRef, {
      status: "Completed"
    });

    // update UI immediately
    setProposals(prev =>
      prev.filter(p => p.id !== proposal.id) // remove from Not Sent list
    );

    alert("Proposal marked as Completed.");
  } catch (error) {
    console.error("Error marking proposal as Completed:", error);
    alert("Could not update status.");
  }
};



const handleMarkNotApproved = async (proposal) => {
  const confirmed = window.confirm("Mark this proposal as Not Approved?");
  if (!confirmed) return;

  try {
    const proposalRef = doc(db, "proposals", proposal.id);
    await updateDoc(proposalRef, {
      status: "Not Approved",
      notApprovedAt: new Date().toISOString(),
      hasBeenSent: proposal.hasBeenSent || false,
    });

    setProposals((prev) => prev.filter((p) => p.id !== proposal.id));

    if (selectedProposal?.id === proposal.id) {
      setSelectedProposal(null);
    }
  } catch (error) {
    console.error("Error marking proposal not approved:", error);
    alert("Failed to mark proposal Not Approved.");
  }
};

const handleToggleStatus = async (proposal, type) => {
  const proposalRef = doc(db, "proposals", proposal.id);
  let newStatus = proposal.status;
  let hasBeenSent = proposal.hasBeenSent || false;

  if (type === "sent") {
    if (proposal.status === "Not Sent") {
      newStatus = "Sent";
      hasBeenSent = true;
    } else if (proposal.status === "Sent") {
      newStatus = "Not Sent";
      hasBeenSent = false;
    } else if (proposal.status === "Approved") {
      hasBeenSent = !hasBeenSent;
    }
  } else if (type === "approval") {
    newStatus = "Approved";
    hasBeenSent = true;
  }

  try {
    await updateDoc(proposalRef, {
      status: newStatus,
      hasBeenSent,
    });

    setProposals((prev) =>
      prev.map((p) =>
        p.id === proposal.id ? { ...p, status: newStatus, hasBeenSent } : p
      )
    );

    // 👇 Add job when proposal just got approved
    if (proposal.status !== "Approved" && newStatus === "Approved") {
      const freshSnap = await getDocs(query(collection(db, "proposals"), where("__name__", "==", proposal.id)));
      const fresh = freshSnap.docs[0]?.data() || proposal;
      await upsertJobFromProposal({ id: proposal.id, ...fresh });
    }
    
  } catch (error) {
    console.error("Error updating status:", error);
    alert("Failed to update proposal status.");
  }
};

const getNextWorkOrder = async (prefix) => {
  const counterRef = doc(db, "counters", `${prefix}_jobs`);
  let nextNumber;

  await runTransaction(db, async (tx) => {
    const snap = await tx.get(counterRef);

    if (!snap.exists()) {
      // first time: start at 10001
      nextNumber = 10001;
      tx.set(counterRef, { lastNumber: nextNumber, updatedAt: serverTimestamp() });
    } else {
      const data = snap.data() || {};
      const last = Number(data.lastNumber);
      const safeLast = Number.isFinite(last) ? last : 10000;
      nextNumber = safeLast + 1;
      tx.update(counterRef, { lastNumber: nextNumber, updatedAt: serverTimestamp() });
    }
  });

  return `${prefix}-${nextNumber}`;
};

const handleSortBySite = () => {
  const sorted = [...proposals].sort((a, b) => {
    const nameA = a.siteName?.toLowerCase() || "";
    const nameB = b.siteName?.toLowerCase() || "";

    if (sortOrder === "asc") {
      return nameA.localeCompare(nameB);
    } else {
      return nameB.localeCompare(nameA);
    }
  });

  setProposals(sorted);
  setSortOrder(sortOrder === "asc" ? "desc" : "asc");
};


const getProposalTotalAmount = (proposal = {}) => {
  const raw = proposal.proposalTotal ?? proposal.contractAmount ?? proposal.estimatedTotal ?? "";
  const cleaned = String(raw).replace(/[^0-9.-]/g, "");
  const amount = Number(cleaned);
  return Number.isFinite(amount) ? amount : 0;
};

const upsertJobFromProposal = async (proposal) => {
  try {
    const jobsRef = collection(db, "jobs");
    const q = query(jobsRef, where("proposalId", "==", proposal.id));
    const existing = await getDocs(q);

    const images =
      proposal.imageURLs && proposal.imageURLs.length
        ? proposal.imageURLs
        : proposal.images || [];

    if (!existing.empty) {
      const jobDoc = existing.docs[0];
      await updateDoc(doc(db, "jobs", jobDoc.id), {
        status: "Active",
        proposalTotal: getProposalTotalAmount(proposal),
        estimatedTotal: getProposalTotalAmount(proposal),
        contractAmount: getProposalTotalAmount(proposal),
      });
      return jobDoc.id;
    }

    

    // Try to get a WO, but don't fail the whole op if it errors
    let wo = "";
    try {
      wo = await getNextWorkOrder("PJMC");
      await updateDoc(doc(db, "proposals", proposal.id), { wo });
      setProposals(prev => prev.map(p => p.id === proposal.id ? { ...p, wo } : p));
    } catch (e) {
      console.warn("WO generation failed; creating job without WO:", e);
    }

    const ts = new Date();
    const jobData = {
      proposalId: proposal.id,
      companyName: proposal.companyName || "",
      companyAddress: proposal.companyAddress || "",
      companyCityStateZip: proposal.companyCityStateZip || "",
      siteName: proposal.siteName || "",
      management: proposal.management || "",
      managerName: proposal.managerName || "",
      address: proposal.address || "",
      cityStateZip: proposal.cityStateZip || "",
      scope: proposal.scope || "",
      jobDescription: proposal.jobDescription || "",
      price: proposal.price || "",
      proposalTotal: getProposalTotalAmount(proposal),
      estimatedTotal: getProposalTotalAmount(proposal),
      contractAmount: getProposalTotalAmount(proposal),
      submittedDate: proposal.submittedDate || "",
      submittedBy: proposal.submittedBy || "",
      terms: proposal.terms || "",
      warrantyName: proposal.warrantyName || "",
      warranty: proposal.warranty || "",
      images,
      wo,                       // may be ""
      status: "Active",
      createdAt: ts.toISOString(),
    };

    const newJobRef = await addDoc(jobsRef, jobData);

    const totalAmount = getProposalTotalAmount(proposal);
    if (totalAmount > 0 && wo) {
      await addJobTotal({
        jobId: String(wo),
        wo: String(wo),
        proposalId: proposal.id,
        total: totalAmount,
        source: "proposal-approval",
      });
    }

    return newJobRef.id;
  } catch (err) {
    console.error("upsertJobFromProposal error:", err);
    alert("Failed to create/activate job. Check console for details.");
    return null;
  }
};



  return (
    <div className="proposals-container">
      <div style={{ display: "flex", justifyContent: "right" }}>

</div>
      <h2 style={{margin:"0 0 12px 0", textAlign:"center"}}>JMC Completed Proposals</h2>
     

      {isEditing && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>{selectedProposal ? "Edit Proposal" : "Add Proposal"}</h3>
            <form className="form-container" onSubmit={handleSubmit}>
              <label>Logo:</label>
              <select name="logo" value={selectedLogo.name} onChange={handleLogoChange} required>
                {logoOptions.map(option => (
                  <option key={option.name} value={option.name}>{option.name}</option>
                ))}
              </select>
             <label>Company Name:</label>
<input
  type="text"
  name="companyName"
  value={newProposal.companyName}
  readOnly
/>


              <label>Company Address:</label>
              <input type="text" name="companyAddress" value={newProposal.companyAddress} onChange={handleInputChange} readOnly />
              <label>Company City, State, Zip:</label>
              <input type="text" name="companyCityStateZip" value={newProposal.companyCityStateZip} onChange={handleInputChange} readOnly />
              <label>Site Name:</label>
              <select name="siteName" value={newProposal.siteName} onChange={handleSiteNameChange} required>
                <option value="">Select Site Name</option>
                {sortedProperties.map(property => (
                  <option key={property.id} value={property.propertyName}>{property.propertyName}</option>
                ))}
              </select>
              <label>Management:</label>
              <input type="text" name="management" value={newProposal.management} onChange={handleInputChange} readOnly />
              <label>Manager Name:</label>
              <input type="text" name="managerName" value={newProposal.managerName} onChange={handleInputChange} readOnly />
              <label>Address:</label>
              <select name="address" value={newProposal.address} onChange={handleInputChange} required>
                <option value="">Select Address</option>
                {properties.map(property => (
                  <option key={property.id} value={property.address || property.managementAddress}>{property.address || property.managementAddress}</option>
                ))}
              </select>
              <label>City, State, Zip:</label>
              <select name="cityStateZip" value={newProposal.cityStateZip} onChange={handleInputChange} required>
                <option value="">Select City, State, Zip</option>
                {properties.map(property => (
                  <option key={property.id} value={`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}>{`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}</option>
                ))}
              </select>
              <label>Scope:</label>
              <input type="text" name="scope" value={newProposal.scope} onChange={handleInputChange} required />
              <label>Job Description: (Notes: Add ((b)) for bold lines, add ((i)) for italic lines. Bold and italic lines, and spaces have no bullets.) </label>
              <textarea name="jobDescription" value={newProposal.jobDescription} onChange={handleInputChange}></textarea>
              <label>Job Description Preview:</label>
              <div className="job-description-preview">
                {parseJobDescription(newProposal.jobDescription)}
              </div>
              <label>Price:</label>
              <textarea
                name="price"
                value={newProposal.price}
                onChange={handleInputChange}
                rows={3}
                required
              ></textarea>

<label>Proposal Total (Internal Only - does not show on proposal):</label>
<input
  type="number"
  step="0.01"
  min="0"
  name="proposalTotal"
  value={newProposal.proposalTotal || ""}
  onChange={handleInputChange}
  placeholder="Enter total amount for internal accounting"
/>
              <label>Submitted Date:</label>
              <input type="date" name="submittedDate" value={newProposal.submittedDate} onChange={handleInputChange} />
              <label>Submitted By:</label>
              <select
  name="submittedBy"
  value={newProposal.submittedBy}
  onChange={handleInputChange}
>
  <option value="">Select User</option>
  {users.map(user => {
    const initials = `${(user.firstName || "").charAt(0)} ${(user.lastName || "").charAt(0)}`.trim();
    return (
      <option key={user.id} value={initials}>
        {initials}
      </option>
    );
  })}
</select>

              <label>Image Display:</label>
              <input type="file" name="imageDisplay" onChange={handleFileChange} multiple />
              <label>Terms:</label>
              <select name="terms" value={newProposal.terms} onChange={handleInputChange} required>
                <option value="">Select Terms</option>
                {termsOptions.map(term => (
                  <option key={term.name} value={term.content}>{term.name}</option>
                ))}
              </select>
              <label>Warranty:</label>
              <select
                name="warrantyName"
                value={newProposal.warrantyName}
                onChange={handleWarrantyChange}
                required
              >
                <option value="">Select Warranty</option>
                {warrantyOptions.map(opt => (
                  <option key={opt.name} value={opt.name}>{opt.name}</option>
                ))}
              </select>
              <div className="modal-buttons">
                <button type="submit" className="blue-button">Save</button>
                <button type="button" className="red-button" onClick={() => setIsEditing(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="table-container" style={{ maxHeight: "70vh", overflow: "auto" }}>
        <table>
          <thead>
            <tr>
            <th style={{ whiteSpace: "nowrap" }}>
  Site Name
  <button 
    onClick={handleSortBySite}
    style={{
      marginLeft: "6px",
      padding: "2px 6px",
      fontSize: "11px",
      cursor: "pointer"
    }}
  >
    {sortOrder === "asc" ? "▲" : "▼"}
  </button>
</th>
              <th>Scope</th>
              <th>Submitted Date</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
          {proposals.map(proposal => (
  <tr
  key={proposal.id}
  style={{
    backgroundColor:
      proposal.status === "Approved"
        ? "#d4edda" // green
        : proposal.status === "Sent"
        ? "#f8d7da" // pink
        : "transparent"
  }}
>
  <td>{proposal.siteName}</td>
  <td>{proposal.scope}</td>
  <td>{formatDateMMDDYYYY(proposal.submittedDate)}</td>
  <td>{formatInitials(proposal.submittedBy)}</td>
  <td>
  <button className="smalldetails-button" onClick={() => setSelectedProposal(proposal)}>Details</button>
  <button className="smalldelete-button" onClick={() => handleDeleteProposalDirect(proposal.id)} style={{ marginLeft: "8px" }}>Delete</button>
  <button
    className={`smallstatus-button ${proposal.status === "Approved" ? "approved" : ""}`}
    onClick={() => handleToggleStatus(proposal, "approval")}
    style={{ marginLeft: "8px" }}
  >
    Approved
  </button>
  <button
    className="smallstatus-button not-approved"
    onClick={() => handleMarkNotApproved(proposal)}
    style={{ marginLeft: "8px" }}
  >
    Not Approved
  </button>
  <button
    className={`smallstatus-button ${proposal.hasBeenSent ? "sent" : ""}`}
    onClick={() => handleToggleStatus(proposal, "sent")}
    style={{ marginLeft: "8px" }}
  >
    {proposal.hasBeenSent ? "Sent" : "Not Sent"}
  </button>
  <button
  className="smallcomplete-button"
  onClick={() => handleMarkCompleted(proposal)}
  style={{ marginLeft: "8px" }}
>
  Completed
</button>
</td>

</tr>

))}


          </tbody>
        </table>
      </div>

      {selectedProposal && (
        <div className="modal full-size-modal"> {/* Add full-size-modal class */}
          {isEditing ? (
            <div className="form-container shrink-form"> {/* Add shrink-form class */}
             <label>Company Name:</label>
<input
  type="text"
  name="companyName"
  value={newProposal.companyName}
  readOnly
/>


              <label>Company Address:</label>
              <input type="text" name="companyAddress" value={newProposal.companyAddress} onChange={handleInputChange} readOnly />
              <label>Company City, State, Zip:</label>
              <input type="text" name="companyCityStateZip" value={newProposal.companyCityStateZip} onChange={handleInputChange} readOnly />
              <label>Site Name:</label>
              <select name="siteName" value={newProposal.siteName} onChange={handleSiteNameChange} required>
                <option value="">Select Site Name</option>
                {sortedProperties.map(property => (
                  <option key={property.id} value={property.propertyName}>{property.propertyName}</option>
                ))}
              </select>
              <label>Management:</label>
              <input type="text" name="management" value={newProposal.management} onChange={handleInputChange} readOnly />
              <label>Manager Name:</label>
              <input type="text" name="managerName" value={newProposal.managerName} onChange={handleInputChange} readOnly />
              <label>Address:</label>
              <select name="address" value={newProposal.address} onChange={handleInputChange} required>
                <option value="">Select Address</option>
                {properties.map(property => (
                  <option key={property.id} value={property.address || property.managementAddress}>{property.address || property.managementAddress}</option>
                ))}
              </select>
              <label>City, State, Zip:</label>
              <select name="cityStateZip" value={newProposal.cityStateZip} onChange={handleInputChange} required>
                <option value="">Select City, State, Zip</option>
                {properties.map(property => (
                  <option key={property.id} value={`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}>{`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}</option>
                ))}
              </select>
              <label>Scope:</label>
              <input type="text" name="scope" value={newProposal.scope} onChange={handleInputChange} required />
              <label>Job Description:</label>
<textarea
  name="jobDescription"
  value={newProposal.jobDescription}
  onChange={handleInputChange}
  rows={6}
/>

<label>Job Description Preview:</label>
<div className="job-description-preview">
  {newProposal.jobDescription.split("\n").map((line, index) => {
    if (line.trim() === "") {
      return <br key={index} />; // Preserve blank lines
    } else if (line.startsWith("((b))")) {
      return <span key={index} className="job-bold"><strong>{line.replace("((b))", "").trim()}</strong><br /></span>;
    } else if (line.startsWith("((i))")) {
      return <span key={index} className="job-italic"><i>{line.replace("((i))", "").trim()}</i><br /></span>;
    } else {
      return <span key={index} className="job-bullet">• {line} <br /></span>;
    }
  })}
</div>

              <label>Price:</label>
              <textarea
                name="price"
                value={newProposal.price}
                onChange={handleInputChange}
                rows={3}
                required
              ></textarea>

<label>Proposal Total (Internal Only - does not show on proposal):</label>
<input
  type="number"
  step="0.01"
  min="0"
  name="proposalTotal"
  value={newProposal.proposalTotal || ""}
  onChange={handleInputChange}
  placeholder="Enter total amount for internal accounting"
/>
              <label>Submitted Date:</label>
              <input type="date" name="submittedDate" value={newProposal.submittedDate} onChange={handleInputChange} />
              <label>Submitted By:</label>
              <select
  name="submittedBy"
  value={newProposal.submittedBy}
  onChange={handleInputChange}
>
  <option value="">Select User</option>
  {users.map(user => {
    const initials = `${(user.firstName || "").charAt(0)} ${(user.lastName || "").charAt(0)}`.trim();
    return (
      <option key={user.id} value={initials}>
        {initials}
      </option>
    );
  })}
</select>

              <label>Image Display:</label>
              <input type="file" name="imageDisplay" onChange={handleFileChange} multiple />
              <label>Terms:</label>
              <select name="terms" value={newProposal.terms} onChange={handleInputChange} required>
                <option value="">Select Terms</option>
                {termsOptions.map(term => (
                  <option key={term.name} value={term.content}>{term.name}</option>
                ))}
              </select>
              <label>Warranty:</label>
              <select
                name="warrantyName"
                value={newProposal.warrantyName}
                onChange={handleWarrantyChange}
                required
              >
                <option value="">Select Warranty</option>
                {warrantyOptions.map(opt => (
                  <option key={opt.name} value={opt.name}>{opt.name}</option>
                ))}
              </select>
              <div className="modal-buttons">
                <button onClick={handleEditProposal} className="blue-button">Save</button>
                <button onClick={handleCancel} className="red-button">Cancel</button>
              </div>
            </div>
          ) : (
            <div id="printableArea" className="printable-content full-size-content"> {/* Add full-size-content class */}
              <div className="page-border">
                <div className="proposals-container">
                  {/* .companylogo-container */}
                  <div className="companylogo-container">
                    <img src={selectedLogo.url} alt="Company Logo" className={`resizable-logo ${selectedLogo.alignment}`} />
                  </div>

                  {/* .companyinfo-container and .property-container */}
                  <div className="row-container">
                    <div className="companyinfo-container bordered-box common-shadow">
                      <p><strong>{selectedProposal.companyName}</strong></p>
                      <p><strong>{selectedProposal.companyAddress}</strong></p>
                      <p><strong>{selectedProposal.companyCityStateZip}</strong></p>
                    </div>
                    <div className="property-container bordered-box">
                      <p><strong>{selectedProposal.siteName}</strong></p>
                      <p><strong>{selectedProposal.management}</strong></p>
                      <p><strong>{selectedProposal.address}</strong></p>
                      <p><strong>{selectedProposal.cityStateZip}</strong></p>
                    </div>
                  </div>

                  {/* .scope-container */}
                  <div className="scope-container bordered-box">
                    <p><strong>Scope:</strong> {selectedProposal.scope}</p>
                  </div>

                  {/* .description-container */}
                  <div className="description-container bordered-box">
                    <p><strong>Job Description:</strong></p>
                    <p className="job-description">
                      {selectedProposal.jobDescription.split("\n").map((line, index) => {
                        if (line.trim() === "") {
                          return <br key={index} />;
                        } else if (line.startsWith("((b))")) {
                          return <span key={index} className="job-bold"><strong>{line.replace("((b))", "").trim()}</strong><br /></span>;
                        } else if (line.startsWith("((i))")) {
                          return <span key={index} className="job-italic"><i>{line.replace("((i))", "").trim()}</i><br /></span>;
                        } else {
                          return <span key={index} className="job-bullet">• {line} <br /></span>;
                        }
                      })}
                    </p>
                  </div>

                  {/* .total-container */}
                  <div className="total-container bordered-box common-shadow">
  <p className="total-text"><strong>{selectedProposal.price}</strong></p>
</div>

                  {/* .noteacceptance-container */}
                  <div className="noteacceptance-container centered-text">
                    <p><strong>NOTE: Please note that any change orders to the work proposed due to items discovered during demolition will be communicated to the owner and agreed upon before work commences.</strong></p>
                  </div>

                   {/* .acceptance-container */}
                   <div className="acceptance-container centered-text">
                    <p><strong>Submitted by:</strong> {formatInitials(selectedProposal.submittedBy)} {formatDateMMDDYYYY(selectedProposal.submittedDate)}</p>
                    <p><strong></strong><i> This proposal may be withdrawn if not accepted within 30 days.</i></p>
                    <p><i>Acceptance of Proposal: The above prices, specifications, and conditions are satisfactory and are hereby accepted. You are authorized to do the work as specified. Payment will be made as outlined below. In the event payment shall not be made as specified, I agree to pay all reasonable costs and expenses of collection, including but not limited to attorney’s fees, whether or not suit is actually filed. A monthly service charge in the amount of 1.5% ($5.00 minimum) will be applied to amounts 30 days overdue or greater.</i></p>
                    <div className="signature-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "20px" }}>
                      <p><strong>Signature: ______________________________</strong></p>
                      <p><strong>Date: ____________________</strong></p>
                    </div>
                  </div>

                  {/* .image-container */}
                  {/* Only render image container if there are image URLs */}
{selectedProposal.imageURLs && selectedProposal.imageURLs.length > 0 && (
  <div className="image-container bordered-box">
    <div className="image-grid">
      {selectedProposal.imageURLs.map((imageUrl, index) => (
        <div key={index} className="image-wrapper">
          <img
            src={imageUrl}
            alt={`Uploaded ${index + 1}`}
            className="proposal-image"
          />
        </div>
      ))}
    </div>
  </div>
)}


                  {/* Add a page break before .terms-container */}

                  {/* .terms-container */}
                  <div className="terms-container bordered-box">
                    <p><strong>Terms and Conditions:</strong> {selectedProposal.terms}</p>
                  </div>

                  {/* .warranty-container */}
                  {selectedProposal.warrantyName !== "No Warranty" && selectedProposal.warranty && (
  <>
    <div className="warranty-container bordered-box">
      <p><strong>Warranty:</strong> {selectedProposal.warrantyName}</p>
    </div>
    <div className="warranty-container bordered-box">
      {selectedProposal.warranty.split("\n").map((line, i) => (
        <p key={i}>{line}</p>
      ))}
    </div>
  </>
)}

                </div>
              </div>



              <div className="no-print">
  <div className="modal-buttons">
    <button onClick={handlePrint} className="blue-button">Print/Download</button>
    <button onClick={() => setIsEditing(true)} className="blue-button">Edit</button>
    <button onClick={handleCloseDetails} className="green-button">Close</button>
    {pdfDownloadUrl && (
      <div style={{ marginTop: "10px" }}>
        <a
          href={pdfDownloadUrl}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="blue-button"
        >
          Download PDF
        </a>
      </div>
    )}
  </div>
  <a id="pdfLink" href="#" target="_blank"></a>
  <iframe id="pdfViewer" width="100%" height="600px"></iframe>
</div>
</div>
          )}
        </div>
      )}

      {showDeleteConfirm && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Are you sure you want to delete?</h3>
            <div className="modal-buttons">
              <button onClick={handleDeleteProposal} className="red-button">Yes</button>
              <button onClick={() => setShowDeleteConfirm(false)} className="green-button">No</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompletedProposals;

